import { FC } from 'react';

import { BannerImageCropType } from 'utils/constants/banner';

import resetImageQuickstartButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_design/reset_image_quickstart_button_click';
import { GridColumn, GridRow, VSpacingContainer } from '@hh.ru/magritte-ui';
import { UturnLeftOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import { useShowAiImageGeneration } from 'hooks/useShowAiImageGeneration';

import { BannerText } from 'components/AdQuickCreate/BannerText';
import { BannerTitle } from 'components/AdQuickCreate/BannerTitle';
import { CampaignBudget } from 'components/AdQuickCreate/CampaignBudget';
import { CampaignSources } from 'components/AdQuickCreate/CampaignSources';
import { ImageGeneration } from 'components/AdQuickCreate/ImageGeneration/ImageGeneration';
import Vacancy from 'components/AdQuickCreate/Vacancy';
import { AiImageGenerationModal } from 'components/common/BannerImg/AiImageGenerationModal/AiImageGenerationModal';
import { CropImageModal } from 'components/common/BannerImg/CropImageModal/CropImageModal';
import { MagritteBannerPreviewSidebar } from 'components/common/MagritteBannerPreviewSidebar/MagritteBannerPreviewSidebar';

import {
    QuickCampaignFieldName,
    resetQuickCampaignBannerImages,
    resetQuickCampaignCroppedImages,
    selectQuickCampaignFormDataField,
} from 'store/models/createQuickCampaign';
import { selectMainMenuVacancyId } from 'store/models/mainMenu';
import { useDispatch, useSelector } from 'store/utils';

const AdQuickCreate: FC = () => {
    const isMainMenuVacancyExist = useSelector(selectMainMenuVacancyId);
    const vacancyId = useSelector(selectQuickCampaignFormDataField[QuickCampaignFieldName.VacancyId]);
    const title = useSelector(selectQuickCampaignFormDataField[QuickCampaignFieldName.Title]);
    const text = useSelector(selectQuickCampaignFormDataField[QuickCampaignFieldName.Text]);
    const image = useSelector((state) => state.createQuickCampaign.images[BannerImageCropType.HH].url) || '';
    const croppedImages = useSelector(selectQuickCampaignFormDataField[QuickCampaignFieldName.CroppedImages]);

    const dispatch = useDispatch();

    const showAiGeneration = useShowAiImageGeneration(true);

    return (
        <>
            <GridRow>
                <GridColumn xs={4} s={8} m={7} l={6}>
                    <VSpacingContainer default={32}>
                        {!isMainMenuVacancyExist && <Vacancy />}
                        <BannerTitle />
                        <BannerText />
                        {showAiGeneration && <ImageGeneration />}
                        <CampaignSources />
                        <CampaignBudget />
                    </VSpacingContainer>
                </GridColumn>
                <GridColumn xs={0} l={2} />
                <GridColumn xs={4} s={8} m={5} l={4}>
                    <MagritteBannerPreviewSidebar
                        title={title}
                        text={text}
                        image={image}
                        vacancyId={vacancyId ? Number(vacancyId) : null}
                        bannerImageBadge={
                            croppedImages && (
                                <UturnLeftOutlinedSize16
                                    initialColor="contrast"
                                    padding={8}
                                    borderRadius="halfHeight"
                                    backgroundStyle="accent"
                                    onClick={() => {
                                        resetImageQuickstartButtonClick();
                                        dispatch([
                                            resetQuickCampaignBannerImages(null),
                                            resetQuickCampaignCroppedImages(null),
                                        ]);
                                    }}
                                />
                            )
                        }
                    />
                </GridColumn>
            </GridRow>

            <CropImageModal isQuickCampaign />
            <AiImageGenerationModal isQuickCampaign />
        </>
    );
};

export default AdQuickCreate;
